<script>
  import Video from "./Video.svelte";
  import Navbar from "./Navbar.svelte";
  import metacombined from "./metacombined.json";
  import BigNumber from "bignumber.js";
  import { COLLECTION_ID } from "./constants";

  import { onMount } from "svelte";

  onMount(() => {
    window.scrollTo(0, 0);
  });

  export let id;

  let boy = metacombined[id];
  let descriptionChunks = boy.description.split("\n").map((d) => d.split(":"));

  let ordersMap = {};
  fetch(
    "https://api.rarible.com/protocol/v0.1/ethereum/order/orders/sell/byCollection?collection=" +
      COLLECTION_ID
  )
    .then((r) => {
      return r.json();
    })
    .then(({ orders }) => {
      console.log(orders);
      orders.forEach((order) => {
        ordersMap[order.make.assetType.tokenId] = order;
      });
    });

  function formatOrder(order) {
    try {
      return new BigNumber(order.take.value)
        .div("1000000000000000000")
        .toNumber();
    } catch (e) {
      console.error(e);
      return "err";
    }
  }
</script>

<div class="bg-blackSplash text-white min-h-full">
  <Navbar dark={true} />
  <div class="md:p-20 p-10 text-center">
    <h3 class="font-pixel mb-10 text-center text-4xl">
      THE BOYS >> {boy.name}
    </h3>
    <div class="flex justify-center">
      <div
        class="m-4 flex items-center flex-col transition duration-300 text-center bg-gray-800 p-3 rounded-lg xlg:max-w-5xl max-w-3xl"
      >
        <Video
          poster={boy.image}
          autoplay="autoplay"
          size=""
          src={boy.animation_url}
        />
        <h5 class="font-pixel text-3xl md:text-5xl p-6">{boy.name}</h5>
        <p
          class="mb-4 text-2xl md:text-3xl underline self-start"
          target="_blank"
        >
        {#if boy.contract}
          <a
            class="font-pixel"
            href="https://zora.co/collections/{boy.contract}/{id}"
            >View on Zora</a
          >
        {:else}
          <a
            class="font-pixel"
            href="https://rarible.com/token/{boy.contract || "0xadc60305b9df338f1b5adc09e2cba69178465739"}:{id}"
            >Purchase on Rarible</a
          >
        {/if}
        </p>

        {#if ordersMap[id] && ordersMap[id].fill === "0" && ordersMap[id].cancelled === false}
          <div class="mb-4 text-2xl font-pixel self-start">
            Price: {formatOrder(ordersMap[id])} eth
          </div>
        {:else}
          <div class="mb-4 text-2xl font-pixel self-start">
            Not for sale yet
          </div>
        {/if}
        <div
          class="text-left text-2xl md:text-3xl font-pixel text-gray-300 line-height-0.5 self-start"
        >
          {#each descriptionChunks as descriptionChunk}
            <p class="">
              <strong>{descriptionChunk[0]}</strong><br />
              {descriptionChunk[1] || ""}
            </p>
          {/each}
        </div>
      </div>
    </div>
  </div>
</div>
